import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { modals } from '@/mixins/modal';
import { guid } from '@/mixins/guid';
import { TheMask } from 'vue-the-mask';
import states from '@/payloads/states.json';
import countries from '@/payloads/countries.json';
import DeleteAccount from './delete';
import PreviousTransactions from './previous-transactions';

export default Vue.component('billing', {
  template: require('./template.html'),
  name: 'billing',
  mixins: [modals, guid],
  computed: {
    ...mapGetters([
      'websites',
      'users',
      'currentUser',
      'priceSource',
      'status',
      'identityId',
      'account',
      'stormUser',
    ]),
    nextTotalAmount() {
      return this.discount ? this.discount.formattedTotal : this.allPeriodTotals;
    },
    accountCodes() {
      const codes = [];
      if (this._isBundle) {
        codes.push('AppSumo');
      }
      return codes;
    },
    invalidPayment() {
      return this.payment && (!this.payment.last4 || this.payment.last4 === '');
    },
    allTypes() {
      const range = [
        {
          name: 'Select',
          _id: null,
        },
        {
          name: 'AppSumo',
          _id: 'appsumo',
        }];
      const search = new RegExp(this.searchTypes, 'gi');
      return _.filter(range, p => p.name.match(search));
    },
  },
  components: {
    TheMask,
    DeleteAccount,
    PreviousTransactions,
  },
  data() {
    return {
      loading: false,
      bareMin: '...loading',
      currentOwner: null,
      selectedOwner: '',
      newCard: false,
      saveError: false,
      payment: false,
      nextPayment: false,
      nextPaymentAmount: 0,
      allPeriodTotals: 0,
      nextPaymentDate: '',
      changePayment: false,
      chargeList: [],
      cardnum: '',
      cardname: '',
      cardaddr: '',
      cardcode: '',
      cardcity: '',
      cardzip: '',
      discountcode: '',
      accountcode: '',
      addCodes: false,
      showCodeTypes: false,
      searchTypes: '',
      selectedType: 'Select',
      loaders: {
        discount: false,
        accountCode: false,
      },
      errorList: {
        discount: false,
        accountCode: false,
      },
      selectedmonth: 'Month',
      months: ['Month'],
      selectedyear: 'Year',
      years: ['Year'],
      selectedstate: 'State',
      states: ['State'],
      selectedcountry: 'Country',
      countries: ['Country'],
      selectedplan: null,
      plans: ['Choose...'],
      input: {
        cc: {
          valid: false,
          type: null,
        },
      },
      taxPercent: 0,
      taxTotal: null,
      discount: null,
      modals: {
        deleteAccount: false,
      },
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      invoice: {},
      invoiceItemTaxes: {},
      acc: [],
      showBreakdown: false,
      stripeError: false,
      stripeDiscountOption: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    // only allow user to logout if delinquent
    if (
      (['delinquent', 'expired'].includes(this.status) && to.name === 'app-login') ||
      !['delinquent', 'expired'].includes(this.status)
    ) {
      next();
    } else {
      // if delinquent, don't allow to go anywhere else other than on the payment page
      next(false);
    }
  },
  created() {
    this.buildExpOptions();
    this.getBillingInfo();
  },
  mounted() {
    // used for the modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  watch: {
    changePayment(open) {
      if (open) {
        this.showBreakdown = false;
      }
    },
    addCodes(open) {
      if (open) {
        this.selectedType = 'Select';
        this.accountcode = '';
        this.errorList.accountCode = false;
      }
    },
  },
  methods: {
    async getBillingInfo() {
      this.loading = true;
      try {
        this.stripeError = false;
        const billingInfo = await this._SEND([{
          name: 'getBillingInfo',
          payload: {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }]);
        if (!billingInfo.card) {
          this.payment = false;
          this.newCard = true;
        } else {
          const card = billingInfo.card;
          this.payment = card;
          this.selectedyear = card.exp_year;
          this.selectedmonth = card.exp_month;
          this.cardname = card.name;
          this.cardaddr = card.address_line1;
          this.cardcity = card.address_city;
          this.cardzip = card.address_zip;
          this.selectedstate = card.address_state;
          this.selectedcountry = card.address_country;
          // setup billing summary
          this.allPeriodTotals = billingInfo.allPeriodTotals;
          this.invoice = billingInfo.invoice;
          this.invoiceItemTaxes = billingInfo.invoiceItemTaxes;
          this.nextPayment = billingInfo.nextPayment;
          this.nextPaymentAmount = billingInfo.nextPaymentAmount;
          this.nextPaymentDate = billingInfo.nextPaymentDate;
          this.taxPercent = billingInfo.taxPercent;
          this.taxTotal = billingInfo.taxTotal;
          this.discount = billingInfo.discount;
          this.chargeList = billingInfo.chargeList;
        }
      } catch (e) {
        this.$log.error(e);
        this.stripeError = 'Oops, There was an issue fetching your billing summary.';
        await this._reportError({
          error: e,
          fn: 'getBillingInfo',
        });
      } finally {
        this.loading = false;
      }
    },
    async applyAccountCode() {
      this.$validator.validate('accountcode', this.accountcode).then(async (result) => {
        if (result) {
          this.loaders.accountCode = true;
          this.errorList.accountCode = false;
          try {
            const notif = {
              type: 'success',
              id: this.guid(),
              message: 'Account code added successfully!',
            };
            const update = await this._SEND([{
              name: 'applyAccountCode',
              payload: {
                code: this.accountcode,
                selectedType: this.selectedType,
              },
            }]);
            this.$log.debug('account code update: ', update);
            this.$store.dispatch('setGlobalValue', {
              item: this.account,
              key: update.key,
              value: update.value,
            });
            this.$store.dispatch('setGlobalValue', {
              item: this.currentUser,
              key: update.key,
              value: update.value,
            });
            this.$store.dispatch('addNotification', notif);
            this.addCodes = false;
          } catch (e) {
            this.$log.error(e);
            this.errorList.accountCode = e.message || e;
            await this._reportError({
              error: e,
              fn: 'applyAccountCode',
            });
          } finally {
            this.loaders.accountCode = false;
            this._trackEvent({
              type: 'apply_account_code',
              meta: {
                code: this.accountcode,
              },
            });
          }
        }
      });
    },
    selectType(type) {
      if (type.name !== 'Select') {
        this.selectedType = type.name;
        this.showCodeTypes = false;
      }
    },
    async applyDiscount() {
      // this is for the COVID/NCNP stripe discounts
      this.loaders.discount = true;
      this.errorList.discount = false;
      try {
        const discounts = this.currentUser.services.stripe.discounts;
        if (this.discountcode === '') {
          this.errorList.discount = 'The discount code cannot be empty';
          return;
        }
        if (discounts && discounts.includes(this.discountcode)) {
          this.errorList.discount = `Your account has already used the ${this.discountcode} discount.`;
          return;
        }
        const services = await this._SEND([{
          name: 'applyDiscount',
          payload: {
            code: this.discountcode,
          },
        }]);
        // add discount code to local state
        this.$store.dispatch('setGlobalValue', {
          item: this.currentUser,
          key: 'services',
          value: services,
        });
        this.discountcode = '';
        // get billing info again
        await this.getBillingInfo();
        // after all is successful, show success notification
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Discount code successfully added!',
        });
      } catch (e) {
        this.$log.error(e);
        this.errorList.discount = e.message || e;
        await this._reportError({
          error: e,
          fn: 'applyDiscount',
        });
      } finally {
        this.loaders.discount = false;
        this._trackEvent({
          type: 'apply_discount',
          meta: {
            code: this.discountcode,
          },
        });
      }
    },
    toggleSummary(key) {
      if (this.acc.includes(key)) {
        const i = _.findIndex(this.acc, s => s === key);
        this.acc.splice(i, 1);
      } else {
        this.acc.push(key);
      }
    },
    saveChanges() {
      this.$validator.validateAll().then(async (result) => {
        if (result && this.changePayment) {
          this.loading = true;
          this.checkCardInput();
          // setup notification
          const notif = {
            type: 'success',
            id: this.guid(),
            message: 'Card saved successfully!',
          };
          // if there is no payment method on file
          try {
            let card = {
              name: this.cardname,
              exp_month: this.selectedmonth,
              exp_year: this.selectedyear,
              address_zip: this.cardzip,
            };

            if (this.cardnum !== '' && this.cardcode !== '') {
              card = {
                ...card,
                number: this.cardnum,
                cvc: this.cardcode,
              };
            }

            const payload = await this._SEND([{
              name: 'updatePayment',
              payload: {
                startingDate: false,
                payment: this.payment,
                newCard: this.newCard,
                card,
              },
            }]);

            // update state with any account updates
            if (payload.newPlan) {
              this.$store.dispatch('updateAccount', {
                plan: payload.newPlan,
              });
            }

            if (payload.paymentMethod) {
              this.$store.dispatch('setGlobalValue', {
                item: this.currentUser,
                key: 'paymentMethod',
                value: payload.paymentMethod,
              });
            }

            if (payload.newStatus) {
              this.$store.dispatch('setAccountStatus', { status: 'active' });
            }

            // reset locals
            this.changePayment = false;
            this.newCard = false;
            this.showBreakdown = false;
            this.payment = true;
            // show next payment
            await this.getBillingInfo();
          } catch (e) {
            let error = e.toString();
            let suffix = '. This has been reported.';
            if (error.match(/No such source:/gi)) {
              error = 'Payment method no longer valid. You may need to add a new method.';
              suffix = '';
            }
            notif.type = 'error';
            notif.message = `${error}${suffix}`;
            await this._reportError({
              error: e,
              fn: 'saveChanges',
            });
          } finally {
            this.loading = false;
            this.$store.dispatch('addNotification', notif);
            this._trackEvent({
              type: 'update_payment',
              meta: {
                code: this.discountcode,
              },
            });
          }
        }
      });
    },
    sslCerts() {
      const accountCerts = [];
      _.forEach(this.websites, (site) => {
        if (site.SSL.certs.length > 0) {
          // each site should only have 1 cert.
          accountCerts.push(site.SSL.certs[0]);
        }
      });
      return accountCerts;
    },
    checkCardInput() {
      const visa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
      const mastercard = /^(?:5[1-5][0-9]{14})$/;
      const amexp = /^(?:3[47][0-9]{13})$/;
      const discover = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

      if (this.cardnum.match(visa)) {
        this.input.cc.valid = true;
        this.input.cc.type = 'visa';
      } else if (this.cardnum.match(mastercard)) {
        this.input.cc.valid = true;
        this.input.cc.type = 'mast';
      } else if (this.cardnum.match(amexp)) {
        this.input.cc.valid = true;
        this.input.cc.type = 'amex';
      } else if (this.cardnum.match(discover)) {
        this.input.cc.valid = true;
        this.input.cc.type = 'disc';
      } else {
        this.input.cc.valid = false;
        this.input.cc.type = null;
      }
    },
    toggleChange(type) {
      this[type] = !this[type];
      if (!this[type] && this.payment) {
        this.newCard = false;
      }
    },
    changeText(type) {
      return this[type] ? 'Cancel' : 'Update Payment Method';
    },
    getPrice() {
      return _.find(this.priceSource.plans, { name: this.selectedplan }).price;
    },
    getPeriodTotal(invoices, tax) {
      let total = 0;
      _.forEach(invoices, (inv) => {
        total += inv.amount;
      });
      if (tax) {
        total = tax + total;
      }
      return this.formatDollars(total);
    },
    getAmountClass(num) {
      let cls = 'adminUi-charge-num';
      if (num < 0) {
        cls = 'adminUi-credit-num';
      }
      return cls;
    },
    buildExpOptions() {
      this.states = states.list;
      this.states.splice(0, 0, 'State');
      this.countries = countries.list;
      this.countries.splice(0, 0, 'Country');
      // build months for new cc expiration
      _.range(1, 13).forEach(month => this.months.push(month));
      // build years for new cc expiration
      let thisYear = new Date()
        .getFullYear()
        .toString()
        .substr(-2);
      thisYear = parseInt(thisYear, 10);
      const endRange = thisYear + 11;
      _.range(thisYear, endRange).forEach(year => this.years.push(2000 + year));
    },
    toggleModal(type, c) {
      this.modals[type] = !this.modals[type];
      const content = !c ? this.$refs[type] : this.$refs[type].$el;
      if (this.modals[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
    addMockCard() {
      this.cardnum = '5105105105105100';
      this.cardname = 'Peter Quill';
      this.cardcode = '123';
      this.selectedmonth = 2;
      this.selectedyear = 2025;
      this.cardaddr = '123 starlord drive';
      this.cardcity = 'san antonio';
      this.cardzip = '78223';
      this.selectedstate = 'TX';
      this.selectedcountry = 'US';
    },
    formatDollars(amount) {
      // this will format the penny values given by stripe to dollars
      return (amount / 100)
        .toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
    },
    cvvTip() {
      return `
        <div style="width:250px;">
          <div class="float-left drz-col-5">
            <img
              src="/static/assets/cvv-icon.svg"
              style="width:85%;"
              alt="cvv tip"/>
          </div>
          <div class="float-left drz-col-7">
            The CVV is the 3 digit<br/>
            number located on the<br/>
            back of your credit or<br/>
            debit card.
          </div>
        </div>
      `.trim();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/billing/index.js